import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Login from './Pages/Login/Login';
import Dashboard from './Pages/Dashboard/Dashboard';
import TokenList from './Pages/Token/TokenList';
import TokenListView from './Pages/Token/TokenListView';
import UsersList from './Pages/Users/UsersList';
import SubscriberList from './Pages/Subscriber/SubscriberList';
import SubscriberAdd from './Pages/Subscriber/SubscriberAdd';
import CategoryList from './Pages/Category/CategoryList';
import CategoryView from './Pages/Category/CategoryView';
import CollectionPromotion from './Pages/NewPromotion/CollectionPromotion';
import CategoryAdd from './Pages/Category/CategoryAdd';
import FaqList from './Pages/Faq/FaqList';
import FaqAdd from './Pages/Faq/FaqAdd';
import FaqEdit from './Pages/Faq/FaqEdit';
import AnnouncementList from './Pages/Announcement/AnnouncementList';
import AnnouncementAdd from './Pages/Announcement/AnnouncementAdd';
import AnnouncementEdit from './Pages/Announcement/AnnouncementEdit';
import CmsList from './Pages/Cms/CmsList';
import CmsEdit from './Pages/Cms/CmsEdit';
import ResourceFooterList from './Pages/ResourceFooter/ResourceFooterList';
import ResourceFooterEdit from './Pages/ResourceFooter/ResourceFooterEdit';
import PromotionList from './Pages/Promotion/PromotionList';
import ReportList from './Pages/Report/ReportList';
import SupportList from './Pages/Support/SupportList';
import ServiceFeeEdit from './Pages/ServiceFee/ServiceFeeEdit';
import UserEdit from './Pages/Users/UserEdit';
import ReportView from './Pages/Report/ReportView';
import { useDispatch, useSelector } from 'react-redux';
import { GetToken } from './actions/commonFunction';

import config from './lib/config'
import { Account_Connect, Account_disConnect, Log_In, Log_Out } from './actions/redux/action';
import Protected from './routes/protected';
import { loginCheck } from './actions/users';
import Profile from './Pages/UserProfile/Profile';
import ResourceUpdate from './Pages/ResourceFooter/ResourceUpdate';
import CurrencyAdd from './Pages/Currency/Currency';
import AddToken from './Pages/Currency/currencyAdd';

function App() {

  const dispatch = useDispatch();
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);


  

  const { logincheck } = Wallet_Details;

  useEffect(() => {
    CheckUser();
  }, [logincheck])

  const CheckUser = async () => {
    if (logincheck == 'false') {
      NotLoginReDirect()
    }
    else {
      const usertoken = sessionStorage.getItem('admin_token');
      
      if (usertoken) {
        let resp = await loginCheck()
        
        if (resp.status) {
          dispatch({
            type: Log_In,
            Account_Detail: {
              ...(resp?.data?resp?.data:{}),
              token: usertoken,
              logincheck: 'true',
            }
          })
        }
        else {
          localStorage.removeItem('admin_token');
          document.cookie = config.adminCookieName + "= ; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
          NotLoginReDirect()
        }
      }
      else {
        localStorage.removeItem('admin_token');
        document.cookie = config.adminCookieName + "= ; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        NotLoginReDirect()
      }
    }
  }

  const NotLoginReDirect = () => {

    if (logincheck != 'false') {
      dispatch({
        type: Log_Out,
      })
    }
    // history.push('/');

  }

  const Auth = (logincheck == 'true' || logincheck == 'pending') ? true : false;

  

  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={Auth ? <Dashboard /> : <Login />} />
        <Route path="/login" element={<Protected isSignedIn={!Auth}><Login /></Protected>} />
        <Route path="/dashboard" element={<Protected isSignedIn={Auth}><Dashboard /></Protected>} />
        <Route path="/TokenList" element={<Protected isSignedIn={Auth}><TokenList /></Protected>} />
        <Route path="/viewToken/:Owner/:Id" element={<Protected isSignedIn={Auth}><TokenListView /></Protected>} />
        <Route path="/UserList" element={<Protected isSignedIn={Auth}><UsersList /></Protected>} />
        <Route path="/subscriberlist" element={<Protected isSignedIn={Auth}><SubscriberList /></Protected>} />
        <Route path="/subscriberadd" element={<Protected isSignedIn={Auth}><SubscriberAdd /></Protected>} />
        <Route path="/categorylist" element={<Protected isSignedIn={Auth}><CategoryList /></Protected>} />
        <Route path="/Viewcategory/:id" element={<Protected isSignedIn={Auth}><CategoryView /></Protected>} />
        <Route path="/AddCategory" element={<Protected isSignedIn={Auth}><CategoryAdd /></Protected>} />
        <Route path="/collectionpromotion/:Id" element={<Protected isSignedIn={Auth}><CollectionPromotion /></Protected>} />
        <Route path="/faqList" element={<Protected isSignedIn={Auth}><FaqList /></Protected>} />
        <Route path="/faqadd" element={<Protected isSignedIn={Auth}><FaqAdd /></Protected>} />
        <Route path="/faqedit/:faqId" element={<Protected isSignedIn={Auth}><FaqEdit /></Protected>} />
        <Route path="/announcementlist" element={<Protected isSignedIn={Auth}><AnnouncementList /></Protected>} />
        <Route path="/announcementadd" element={<Protected isSignedIn={Auth}><AnnouncementAdd /></Protected>} />
        <Route path="/announcementedit/:announcementId" element={<Protected isSignedIn={Auth}><AnnouncementEdit /></Protected>} />
        <Route path="/cmslist" element={<Protected isSignedIn={Auth}><CmsList /></Protected>} />
        <Route path="/cmsedit/:Id" element={<Protected isSignedIn={Auth}><CmsEdit /></Protected>} />
        <Route path="/Cms" element={<Protected isSignedIn={Auth}><ResourceFooterList /></Protected>} />
        <Route path="/editcms/:Id" element={<ResourceFooterEdit />} />
        <Route path="/resource/:resourceid" element={<ResourceUpdate />} />
        <Route path="/newpromotionlist" element={<Protected isSignedIn={Auth}><PromotionList /></Protected>} />
        <Route path="/reportlist" element={<Protected isSignedIn={Auth}><ReportList /></Protected>} />
        <Route path="/ViewReport/:Id" element={<Protected isSignedIn={Auth}><ReportView /></Protected>} />
        <Route path="/supportTicket" element={<Protected isSignedIn={Auth}><SupportList /></Protected>} />
        <Route path="/editserviceFee" element={<Protected isSignedIn={Auth}><ServiceFeeEdit /></Protected>} />
        <Route path="/currency" element={<Protected isSignedIn={Auth}><CurrencyAdd /></Protected>} />
        <Route path="/addtoken" element={<Protected isSignedIn={Auth}><AddToken /></Protected>} />
        <Route path="/user" element={<Protected isSignedIn={Auth}><Profile /></Protected>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
